import { arePropsMissing } from '../../../utils/helpers';
import BookingLayout from './BookingLayout';
import BookingForm from '../../../components/bookingForm/containers/BookingForm';
import Meta from '../../../utils/meta/Meta';

import './booking.css';

interface BookingProps {
  display_title: string | undefined;
  accommodation_id: number | undefined;
  booking_id: number | undefined;
  amount: number | undefined;
  arrival: string | undefined;
  current_persons: number | undefined;
  duration_of_stay: number | undefined;
  max_persons: number | undefined;
  comment: string | undefined;
  accommodation_slug: string | undefined;
  options: {
    insurance_countries: unknown[];
    salutations: unknown[];
    payment_methods: unknown[];
  };
  meta: {
    page_title: string | undefined;
  };
}

/* eslint-disable react/destructuring-assignment */

export default function Booking(props: BookingProps): JSX.Element | null {
  if (
    arePropsMissing([
      props.display_title,
      props.accommodation_id,
      props.booking_id,
      props.amount,
      props.arrival,
      props.current_persons,
      props.duration_of_stay,
      props.max_persons,
      props.comment,
      props.accommodation_slug,
      props.options,
      props.meta,
    ])
  ) {
    return null;
  }
  return (
    <BookingLayout {...props}>
      <Meta title={props.meta.page_title} />
      <BookingForm {...props} />
    </BookingLayout>
  );
}
